import type { ServerMetadata } from "@app/lib/actions/mcp_internal_actions/tool_definition";
import { z } from "zod";

export const GUIDE_ANNOUNCEMENTS_SERVER_NAME = "guide_announcements" as const;
export const LIST_ANNOUNCEMENTS_TOOL_NAME = "list_announcements";
export const MARK_ANNOUNCEMENTS_SEEN_TOOL_NAME = "mark_announcements_seen";

export const GUIDE_ANNOUNCEMENTS_TOOLS_METADATA = [
  {
    name: LIST_ANNOUNCEMENTS_TOOL_NAME,
    description:
      "List the MemoAir product announcements this user has not seen yet, limited to features that work with the apps they have connected.",
    schema: {},
    stake: "never_ask",
    displayLabels: {
      running: "Checking what's new",
      done: "Checked what's new",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
  {
    name: MARK_ANNOUNCEMENTS_SEEN_TOOL_NAME,
    description:
      "Mark announcements as seen once you have told the user about them, so they are not shown again.",
    schema: {
      announcementIds: z
        .array(z.string().min(1).max(200))
        .min(1)
        .max(50)
        .describe("Ids returned by list_announcements."),
    },
    stake: "never_ask",
    displayLabels: {
      running: "Marking announcements seen",
      done: "Marked announcements seen",
    },
    toolCostCategory: "basic",
    freeUsage: true,
  },
] as const;

export const GUIDE_ANNOUNCEMENTS_SERVER = {
  serverInfo: {
    name: GUIDE_ANNOUNCEMENTS_SERVER_NAME,
    version: "1.0.0",
    description:
      "MemoAir product announcements @Guide shares once per user, filtered by their connections.",
    authorization: null,
    icon: "ActionMegaphoneIcon",
    documentationUrl: null,
  },
  tools: GUIDE_ANNOUNCEMENTS_TOOLS_METADATA,
} as const satisfies ServerMetadata;
